import React from 'react';
const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Shena',
    title: 'Acquisition Specialist',
    content: ['The challenge was finding a safe, backed and guaranteed investment vehicle with transparency, greater growth rates on the money invested, and quick access to funds without penalties.', "Legacy lab provided the investment vehicle that aligned better with my financial goals. As such I've seen significant growth in my current investment far beyond past utilized and known financial tools.", "Within the past 6 months I've seen an 18% increase on my investment."]
  }];
  return <section id="testimonials" className="w-full py-24 bg-gradient-to-b from-gold-50 to-white" data-id="element-361">
      <div className="container mx-auto px-4" data-id="element-362">
        <div className="text-center mb-16" data-id="element-363">
          <h2 className="text-4xl font-bold section-title-decoration" data-id="element-364">
            <span className="text-gradient" data-id="element-365">Testimonials</span>
          </h2>
          <p className="text-center text-gray-600 max-w-4xl mx-auto mt-12 mb-16 text-lg fade-in" data-id="element-366">
            Hear from our clients who have transformed their financial futures
            with Legacy Lab Financial.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-8 stagger-container max-w-3xl mx-auto" data-id="element-367">
          {testimonials.map((testimonial, index) => <div key={index} className="testimonial-card fade-item stagger-item stagger-delay-1 shadow-xl" data-id="element-368">
              <div className="space-y-4" data-id="element-369">
                {testimonial.content.map((paragraph, i) => <p key={i} className="text-gray-700 fade-in italic" style={{
              transitionDelay: `${0.1 * i}s`
            }} data-id="element-370">
                    {paragraph}
                  </p>)}
              </div>
              <div className="mt-6 text-right" data-id="element-371">
                <h3 className="text-gold-600 text-xl font-semibold" data-id="element-372">
                  {testimonial.name}
                </h3>
                <p className="text-gray-500 italic" data-id="element-373">{testimonial.title}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;